module.exports = false;



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/is-pure.js